import React from 'react';
import classnames from 'classnames';

const CSS = require('./CounterControl.less');

interface CounterControlProps {
  children: any;
  value?: number;
  minValue?: number;
  maxValue?: number;
  className?: string;
  onIncrease?: () => void;
  onDecrease?: () => void;
}

const CounterControl = ({
  children,
  value,
  minValue,
  maxValue,
  className,
  onIncrease,
  onDecrease 
}: CounterControlProps) => {

  const classes = classnames(CSS.CounterControl, {
    [className]: className,
  });

  const minusButtonClassnames = classnames(CSS.RoundButton, {
    [`${CSS['RoundButton--disabled']}`]: value <= minValue,
  });

  const plusButtonClassnames = classnames(CSS.RoundButton, {
    [`${CSS['RoundButton--disabled']}`]: value >= maxValue,
  });
  
  return (
    <div className={classes}>
      <div className={CSS.Label}>
        {children}
      </div>
      <div className={CSS.ButtonsContainer}>
        <span className={CSS.RoundButtonMinus}>
          <button
            data-test-id="decreaseCounterButton"
            type="button"
            className={minusButtonClassnames}
            onClick={onDecrease}
          >
            <svg width={8} height={2} viewBox="0 0 8 2">
              <line
                x1="0"
                y1="1"
                x2="8"
                y2="1"
                stroke="black"
                strokeWidth="2"
              />
            </svg>
          </button>
        </span>
        <span data-test-id="counterValue" className={CSS.Value}>{value}</span>
        <span className={CSS.RoundButtonPlus}>
          <button
            data-test-id="increaseCounterButton"
            type="button"
            className={plusButtonClassnames}
            onClick={onIncrease}
          >
            <svg width={8} height={8} viewBox="0 0 8 8">
              <line
                x1="4"
                y1="0"
                x2="4"
                y2="8"
                stroke="black"
                strokeWidth="2"
              />
              <line
                x1="0"
                y1="4"
                x2="8"
                y2="4"
                stroke="black"
                strokeWidth="2"
              />
            </svg>
          </button>
        </span>
      </div>
    </div>
  );
};
export default CounterControl;
